import { Group } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const GroupIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Group width={size} height={size} color={color} {...rest} />;

GroupIcon.displayName = 'GroupIcon';

export default GroupIcon;
